<template>
  <div class="qualification-container">
    <!-- 탭 버튼 (라디오 버튼 활용) -->
    <div class="tab-container">
      <input
        type="radio"
        id="tab-special"
        name="tab"
        class="tab-radio"
        checked
      />
      <input type="radio" id="tab-general" name="tab" class="tab-radio" />

      <div class="tab-buttons">
        <label for="tab-special" class="tab-button active">특별공급</label>
        <label for="tab-general" class="tab-button">일반공급</label>
      </div>

      <!-- 공지 사항 -->
      <div class="notice-box">
        <h2 class="section-title">공지사항</h2>
        <ul class="notice-list">
          <li class="notice-item">
            기준일은 모집공고일 기준이며, 이는 청약자의 판단기준일입니다.
          </li>
          <li class="notice-item">
            본 공고에 표시된 연령(나이)은 모집공고일을 기준으로 하며, 신혼부부
            계층의 자격 중 '주택공급신청자의 혼인기간이 7년 이내 (혼인 후
            2,555일)인 자' 도 모집공고일을 기준으로 산정합니다.
          </li>
          <li class="notice-item">
            모든 계층의 신청자 및 입주 예정 세대구성원(신혼부부 계층) 전부는
            무주택요건을 충족해야 합니다.
          </li>
        </ul>
      </div>

      <!-- 청년 신청 자격 -->
      <h2 class="category-title">청년 계층 신청자격</h2>
      <p class="date-info">
        입주자모집공고일 기준 현재 아래의 요건을 모두 갖춘자(외국인 제외)
      </p>

      <h3 class="sub-title">자격조건</h3>

      <!-- 특별공급 탭 내용 -->
      <div class="tab-content" id="special-content">
        <!-- 청년 계층 신청자격 -->
        <div class="condition-box">
          <h4 class="condition-title">안내사항</h4>
          <ul class="condition-list">
            <li class="condition-item">
              해당 세대'란 주민등록등본 상 직계존비속이며 형제자매의 소득은
              제외합니다.
            </li>
            <li class="condition-item">
              '무주택자'란 주택을 소유하고 있지 않은 자를 말합니다.
            </li>
            <li class="condition-item">
              신청자가 소득이 있는 경우 - "해당 세대" 범위 내 소득
            </li>
            <li class="condition-item">
              신청자가 단독 세대주인 경우 - 신청자 본인만의 소득, 세대원 또는
              세대원이 있는 세대주인 경우 - 해당 세대 모두(주민등록등본 기준상
              직계존비속 이며 형제자매의 소득은 제외합니다) 의 소득
            </li>
            <li class="condition-item">
              신청자가 소득이 없는 경우 - "사실증명(신고사실없음)" 제출 후
              신청자와 "부모(가족 관계증명서 기준)"의 월평균 소득합계(신청자
              포함 3인 기준)
            </li>
          </ul>
        </div>

        <ul class="requirement-list">
          <li class="requirement-item">만19세 이상 만 39세 이하인 자</li>
          <li class="requirement-item">미혼</li>
          <li class="requirement-item">무주택자</li>
          <li class="requirement-item">
            소득기준 (해당 세대의 월평균 소득이 전년도 도시근로자
            가구원(태아포함)수별 가구당 월평균 소득의 120% 이하일 것)
          </li>
        </ul>

        <div class="income-notes">
          <span
            >* 전년도(2025년도) 도시근로자 가구원수별 가구당 월평균 소득 기준에
            의함</span
          >
          <span class="right-note">(원)</span>
        </div>

        <!-- 소득기준 표 -->
        <div class="income-table-container">
          <table class="income-table">
            <thead>
              <tr>
                <th>도시근로자 월평균 소득기준</th>
                <th>1인 가구</th>
                <th>2인 가구</th>
                <th>3인 가구</th>
                <th>4인 가구</th>
                <th>5인 가구</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>월평균소득 100%</td>
                <td>3,813,363</td>
                <td>5,866,270</td>
                <td>8,168,429</td>
                <td>8,802,202</td>
                <td>9,326,985</td>
              </tr>
              <tr>
                <td>월평균소득 110%</td>
                <td>4,194,699</td>
                <td>6,452,897</td>
                <td>8,985,272</td>
                <td>9,682,422</td>
                <td>10,259,684</td>
              </tr>
              <tr>
                <td>월평균소득 120%</td>
                <td>4,576,036</td>
                <td>7,039,524</td>
                <td>9,802,115</td>
                <td>10,562,642</td>
                <td>11,192,382</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="income-notes-table">
          <p>
              6인 이상 가구는 5인 가구 소득에 1인당 평균금액을 합산하여 산정
          </p>
          <p class ="sub-item-no-dash">
              * 1인당 평균금액 (579,278원) = (5인 가구 월평균소득 - 3인 가구 월평균소득) / 2
          </p>
          <p class ="sub-item-no-dash">
              → 6인 가구 : 9,906,263원, 7인 가구 : 10,485,541원
          </p>
 
 
          <p>
            A. 소득기준 - 1순위 : 기준소득 100% 이하, 2순위: 기준소득 110% 이하,
            3순위: 기준소득 120% 이하
          </p>
          <p>
            B. 지역 기준 : 동일 소득일 경우 거주지역 우선 거주자, 재학생,
            입(복)학 예정자, 재직자 (대학 및 직장 소재지 포함, 단, 사이버대학교,
            방송통신대학교 제외)
          </p>
          <p class="sub-item">
            1순위 : 해당 공급 대상 주택 소재지(서울특별시 관악구)
          </p>
          <p class="sub-item">
            2순위 : 해당 공급 대상 주택 소지지 외(서울특별시)
          </p>
          <p class="sub-item">
            3순위 : 그 외 지역</p>
          <p>
            ※ 동일 순위 경쟁시 "소득순위 → 지역순위 → 추첨" 순으로 선정 됩니다.
          </p>
          <p>
            ※ 특별공급은 각각의 신청자격을 모두 충족하는 자를 대상으로
            주택형별로 접수하여, 상기 소득 및 해당 지역의 순위에 따라 대상자를
            선정하고 동일 순위 발생 시 공정한 방식에 의한 무작위 추첨으로
            당첨자를 선정하며, 예비입주자 및 예비순번 역시 무작위 추첨으로
            걸정됩니다.
          </p>
          <p>
            ※ 입주자격 조사결과에 따른 '부적격사유'에 대한 소명 의무는 전적으로
            공급신청자에게 있습니다.
          </p>
        </div>

        <ul class="requirement-list">
          <li class="requirement-item">
            자동차(이륜차 포함) 무소유 및 미 운행자 또는 2026년 기준 자동차 가액
            4,542만원 이내의 자동차(이륜차 포함) 소유운행자
          </li>
          <li class="requirement-item">
            2026년 기준 본인 자산 가액 2억 5,100만원 이하
          </li>
        </ul>
      </div>

      <!-- 일반공급 탭 내용 -->
      <div class="tab-content" id="general-content">
        <div class="condition-box">
          <h4 class="condition-title">안내사항</h4>
          <ul class="condition-list">
            <li class="condition-item">
              신청자 본인은 '무주택자' 여야 하며, 세대 내 다른 구성원이 주택을
              소유해도 신청 가능합니다.
            </li>
            <li class="condition-item">
              무주택자'란 주택을 소유하고 있지 않은 자를 말합니다.
            </li>
          </ul>
        </div>

        <ul class="requirement-list">
          <li class="requirement-item">19세 이상 39세 이하인 자</li>
          <li class="requirement-item">미혼</li>
          <li class="requirement-item">무주택자</li>
          <li class="requirement-item">소득 및 자산, 지역 요건 없음</li>
          <li class="requirement-item">
            자동차(이륜차 포함) 무소유 및 미 운행자 또는 2026년 기준 자동차 가액
            4,542만원 이내의 자동차(이륜차 포함) 소유운행자
          </li>
        </ul>

        <!-- <div class="income-table-container">
          <table class="income-table">
            <thead>
              <tr>
                <th>도시근로자 월평균 소득기준</th>
                <th>1인 가구</th>
                <th>2인 가구</th>
                <th>3인 가구</th>
                <th>4인 가구</th>
                <th>5인 가구</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>월평균소득 100%</td>
                <td>3,482,964</td>
                <td>5,415,712</td>
                <td>7,198,649</td>
                <td>8,248,467</td>
                <td>8,775,071</td>
              </tr>
            </tbody>
          </table>
        </div> -->

        <!-- <div class="additional-notes">
          <p>* 일반공급의 경우 동일 순위 내 경쟁 시 추첨의 방법으로 입주자를 선정합니다.</p>
          <p>* 거주지역 우선순위: 1순위(해당 주택건설지역 거주자) → 2순위(기타지역 거주자)</p>
        </div> -->

        <!-- (예비)신혼부부 계층 신청자격 -->
        <h2 class="category-title">(예비)신혼부부 계층 신청자격</h2>
        <p class="date-info">
          ※입주자 모집공고일 기준 현재 아래의 요건을 모두 갖춘자(외국인제외)
        </p>
        <p class="date-info">
          ※(예비)신혼부부이면서 무주택 세대구성원인 경우(소득 및 자산 요건 없음)
        </p>

        <h3 class="sub-title">자격조건</h3>

        <div class="condition-box">
          <h4 class="condition-title">안내사항</h4>
          <ul class="condition-list">
            <li class="condition-item">
              가. 신혼부부는 혼인 후 7년이내(혼인 후 2,555일)의 부부를 말합니다.
            </li>
            <li class="condition-item">
              나. 신혼부부(예비신혼부부 포함)는 1세대로 간주하여 부부(예비부부)
              중 1명이 대표로 1건만 신청이 가능하고, 두 명이 각각 중복 신청할
              경우에는 전부 무효 처리됩니다.
            </li>
            <li class="condition-item">
              다. 신혼부부(예비신혼부부 포함)형은 청약을 신청한 당첨자 명의로
              계약 체결이 가능하며, 부부공동명의 계약은 불가합니다.
            </li>
            <li class="condition-item">
              라. "무주택세대구성원"이란 전원이 주택을 소유하고 있지 않은 세대의
              구성원을 말하며, 이때의 '세대'란 다음의 사람으로 구성된
              집단(신청자가 세대별 주민등록표에 등재되어 있지 않은 경우는
              제외)을 말합니다.
            </li>
          </ul>
          <ul class="sub-list">
            <li class="sub-list-item">신청자 본인</li>
            <li class="sub-list-item">신청자의 배우자</li>
            <li class="sub-list-item">
              신청자의 직계존속(배우자의 직계존속 포함)으로서 신청자 또는
              신청자의 배우자와 동일세대 등재자
            </li>
            <li class="sub-list-item">
              신청자의 직계비속(직계비속의 배우자 포함)으로서 신청자 또는 신청자
              배우자와 동일세대 등재자
            </li>
            <li class="sub-list-item">
              신청자의 배우자의 직계비속으로서 신청자와 동일세대 등재자
            </li>
          </ul>
          <ul class="condition-list">
            <li class="condition-item">
              '무주택자' 란 주택을 소유하고 있지 않은 자를 말합니다.
            </li>
          </ul>
        </div>

        <ul class="requirement-list" id="unique-requirement-list">
          <li class="requirement-item">만19세 이상 만 39세 이하인 자</li>
          <li class="requirement-item">
            신혼부부는 혼인중인 자, 예비신혼부부는 해당 주택의 입주 전까지
            혼인사실을 증명할 수 있는 자
          </li>
          <li class="requirement-item">
            신혼부부의 경우 "무주택세대구성원", 예비신혼부부의 경우 각각
            주택세대
          </li>
          <li class="requirement-item">소득 및 자산, 지역 요건 검증</li>
          <li class="requirement-item">
            자동차(이륜차 포함) 무소유 · 미운행자 또는 2026년 기준 자동차가액
            4,542만원 이내의 자동차(이륜차 포함) 소유 · 운행자
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

// ✅ 각 리스트 번호를 동적으로 설정
onMounted(() => {
  const specialLists = document.querySelectorAll(
    '#special-content .requirement-list'
  )
  const generalLists = document.querySelectorAll(
    '#general-content .requirement-list'
  )

  // ✅ 특별공급 - 번호 카운팅
  let specialCounter = 1
  specialLists.forEach(list => {
    list.querySelectorAll('.requirement-item').forEach(item => {
      item.setAttribute('data-number', specialCounter)
      specialCounter++
    })
  })

  // ✅ 일반공급 - 번호 카운팅
  let generalCounter = 1
  generalLists.forEach(list => {
    list.querySelectorAll('.requirement-item').forEach(item => {
      item.setAttribute('data-number', generalCounter)
      generalCounter++
    })
  })

  const uniqueList = document.querySelector('#unique-requirement-list')
  if (uniqueList) {
    let uniqueCounter = 1
    uniqueList.querySelectorAll('.requirement-item').forEach(item => {
      item.setAttribute('data-number', uniqueCounter)
      uniqueCounter++
    })
  }
})
</script>

<style scoped>
/* 기본 스타일 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans KR', sans-serif;
}

.qualification-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  line-height: 1.6;
}

/* 제목 스타일 */
.main-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.category-title {
  font-size: 22px;
  font-weight: 700;
  margin: 30px 0 15px 0;
  border-bottom: 2px solid #333;
  padding-bottom: 10px;
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  margin: 20px 0 10px 0;
}

.condition-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
}

/* 탭 컨테이너 및 버튼 */
.tab-container {
  position: relative;
  margin-bottom: 30px;
}

.tab-radio {
  display: none; /* 라디오 버튼 숨김 */
}

.tab-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}

.tab-button {
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  background-color: #e0e0e0;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin: 0 5px;
  transition: all 0.3s ease;
  text-align: center;
}

/* 탭 내용 */
.tab-content {
  display: none;
}

/* 탭 선택 시 스타일 변경 */
#tab-special:checked ~ .tab-buttons label[for='tab-special'] {
  background-color: #4a6b82;
  color: white;
}

#tab-general:checked ~ .tab-buttons label[for='tab-general'] {
  background-color: #4a6b82;
  color: white;
}

/* 탭 선택 시 내용 표시 */
#tab-special:checked ~ #special-content {
  display: block;
}

#tab-general:checked ~ #general-content {
  display: block;
}

/* 공지사항 박스 */
.notice-box {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
}

/* 리스트 스타일 */
.notice-list,
.condition-list,
.requirement-list,
.sub-list {
  list-style-type: none;
  padding-left: 20px;
  margin-bottom: 15px;
}

.notice-item,
.condition-item,
.requirement-item {
  position: relative;
  padding-left: 15px;
  margin-bottom: 5px;
}

.notice-item:before,
.condition-item:before {
  content: '·';
  position: absolute;
  left: 0;
  color: #666;
}

.requirement-item {
  position: relative;
  padding-left: 20px;
}

/* ✅ 요구 사항 번호 자동 증가 */
.requirement-item:before {
  content: attr(data-number) '. ';
  position: absolute;
  left: 0;
  color: #666;
  font-weight: bold;
}

/* 
.requirement-item:before {
  content: "①";
  position: absolute;
  left: 0;
  color: #666;
}

.requirement-item:nth-child(2):before {
  content: "②";
}

.requirement-item:nth-child(3):before {
  content: "③";
}

.requirement-item:nth-child(4):before {
  content: "④";
}

.requirement-item:nth-child(5):before {
  content: "⑤";
}

.requirement-item:nth-child(6):before {
  content: "⑥";
}

.requirement-item:nth-child(7):before {
  content: "⑦";
} */

.sub-item {
  padding-left: 30px;
}

.sub-item:before {
  content: '-';
  left: 15px;
}

.sub-item-no-dash {
  padding-left: 30px;
}

.sub-item-no-dash:before {
  left: 15px;
}

.sub-list-item {
  position: relative;
  padding-left: 15px;
  margin-bottom: 5px;
  color: #666;
}

.sub-list-item:before {
  content: '○';
  position: absolute;
  left: 0;
  color: #999;
}

/* 날짜 정보 */
.date-info {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

/* 조건 박스 */
.condition-box {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* 강조 텍스트 */
.highlight-text {
  color: #1a73e8;
  font-weight: 500;
  margin: 15px 0;
}

/* 소득기준 표 */
.income-table-container {
  overflow-x: auto;
  margin: 20px 0;
}

.income-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
}

.income-table th,
.income-table td {
  border: 1px solid #ddd;
  padding: 10px;
}

.income-table th {
  background-color: #f2f2f2;
  font-weight: 600;
}

.income-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.income-notes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: 8px;
}

.income-notes-table {
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: 8px;
}

/* 추가 노트 */
.additional-notes {
  background-color: #f0f7ff;
  padding: 15px;
  border-radius: 8px;
  margin: 20px 0;
  font-size: 14px;
}

.additional-notes p {
  margin-bottom: 8px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .qualification-container {
    padding: 15px;
  }

  .main-title {
    font-size: 24px;
  }

  .category-title {
    font-size: 20px;
  }

  .tab-button {
    padding: 8px 15px;
    font-size: 14px;
  }

  .income-table th,
  .income-table td {
    padding: 8px 5px;
    font-size: 13px;
  }
}
</style>
